import { components } from "react-select";
import { GoTriangleDown } from "react-icons/go";

export const assignmentSelectStyles = {
    control: (baseStyles) => ({
        ...baseStyles,
        height: "52px",
        borderRadius: "5px",
        border: "1px solid #e8e8e8",
        backgroundColor: "#ffffff",
        fontSize: "14px",
        boxShadow: "none",
        "&:hover": {
            border: "1px solid #e8e8e8",
        },
    }),
    valueContainer: (baseStyles) => ({
        ...baseStyles,
        paddingLeft: "8px",
    }),
    menu: (baseStyles) => ({
        ...baseStyles,
        borderRadius: "5px",
        marginTop: "4px",
        zIndex: 40,
    }),
    menuPortal: (baseStyles) => ({
        ...baseStyles,
        zIndex: 40,
    }),
    groupHeading: (baseStyles) => ({
        ...baseStyles,
        fontSize: "11px",
        letterSpacing: "0.06em",
        color: "#8D8D8D",
    }),
    option: (baseStyles, state) => ({
        ...baseStyles,
        fontSize: "14px",
        // A conflicted option stays visible but plainly unusable — the label
        // already says which booking is holding it.
        backgroundColor: state.isDisabled
            ? "#F7F7F7"
            : state.isSelected
                ? "#dbbe78"
                : state.isFocused
                    ? "#eddfbb"
                    : "#ffffff",
        color: state.isDisabled ? "#B5B5B5" : state.isSelected ? "#ffffff" : "#282828",
        cursor: state.isDisabled ? "not-allowed" : "pointer",
    }),
};

export const assignmentSelectComponents = {
    DropdownIndicator: (props) => (
        <components.DropdownIndicator {...props}>
            <div className="tw:pr-2">
                <GoTriangleDown color="#DBBE78" size={16} />
            </div>
        </components.DropdownIndicator>
    ),
    IndicatorSeparator: () => null,
};
